import React from 'react'

import { RedBadge } from '../data-card/data-card-parts'

export default ({
  history,
  technician = {}
}) => (
  <div className='history-item'>
    <p className='timestamp'>
      {completionStatus(history)} by {technician.name} on {completedAt(history)}
      {redoneBadge(history)}
    </p>

    <p>Services: {history.services.join(', ')}</p>
  </div>
)

function redoneBadge(history) {
  if (history.redone) {
    return <RedBadge text='redo' additionalClasses='right' />
  }
}

function completionStatus (history) {
  return {
    completed: 'Completed',
    unable: 'Marked as unable'
  }[history.status]
}

function completedAt (history) {
  if (history && history.completedAt) {
    return history.completedAt.format('MMMM Do, YYYY')
  } else {
    return '—'
  }
}



// WEBPACK FOOTER //
// ./src/components/histories/area-history-item.js